// src/admin/sections/AdminHero.jsx

import { useEffect, useState } from "react";
import { doc, onSnapshot, setDoc } from "firebase/firestore";
import { ref, uploadBytes, getDownloadURL } from "firebase/storage";
import { db, storage } from "../../firebase/config";

export default function AdminHero() {
  const [form, setForm] = useState({
    name: "",
    subtitle: "",
    image: "",
    primaryBtn: "",
    secondaryBtn: ""
  });

  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);
  const [uploading, setUploading] = useState(false);

  // ================= REAL-TIME FETCH (FAST) =================
  useEffect(() => {
    const refDoc = doc(db, "siteContent", "hero");

    const unsubscribe = onSnapshot(refDoc, (snap) => {
      if (snap.exists()) {
        setForm(snap.data());
      }
      setLoading(false);
    });

    return () => unsubscribe();
  }, []);

  // ================= HANDLE INPUT =================
  const handleChange = (e) => {
    setForm({
      ...form,
      [e.target.name]: e.target.value
    });
  };

  // ================= IMAGE UPLOAD =================
  const handleImageUpload = async (file) => {
    if (!file) return;

    try {
      setUploading(true);

      const storageRef = ref(
        storage,
        `hero/${Date.now()}_${file.name}`
      );

      await uploadBytes(storageRef, file);

      const url = await getDownloadURL(storageRef);

      setForm((prev) => ({
        ...prev,
        image: url
      }));

    } catch (err) {
      console.error(err);
      alert("❌ Image upload failed");
    }

    setUploading(false);
  };

  // ================= SAVE DATA =================
  const handleSave = async () => {
    try {
      setSaving(true);

      await setDoc(doc(db, "siteContent", "hero"), form);

      alert("✅ Hero Updated Successfully!");
    } catch (err) {
      console.error(err);
      alert("❌ Error saving data");
    }

    setSaving(false);
  };

  if (loading) return <p>Loading Hero...</p>;

  return (
    <div className="admin-hero">

      <h2>Hero Section</h2>

      {/* ================= FORM ================= */}
      <div className="admin-form">

        <input
          name="name"
          placeholder="Name"
          value={form.name}
          onChange={handleChange}
        />

        <input
          name="subtitle"
          placeholder="Subtitle"
          value={form.subtitle}
          onChange={handleChange}
        />

        {/* 🔥 IMAGE UPLOAD */}
        <div className="image-upload">
          <input
            type="file"
            onChange={(e) => handleImageUpload(e.target.files[0])}
          />

          {uploading && <p>Uploading image...</p>}
        </div>

        <input
          name="primaryBtn"
          placeholder="Primary Button Text"
          value={form.primaryBtn}
          onChange={handleChange}
        />

        <input
          name="secondaryBtn"
          placeholder="Secondary Button Text"
          value={form.secondaryBtn}
          onChange={handleChange}
        />

      </div>

      {/* ================= PREVIEW ================= */}
      <div className="hero-preview">
        {form.image && <img src={form.image} alt="preview" />}
        <h3>{form.name || "Name Preview"}</h3>
        <p>{form.subtitle || "Subtitle Preview"}</p>
      </div>

      {/* ================= SAVE BUTTON ================= */}
      <button
        className="save-btn"
        onClick={handleSave}
        disabled={saving || uploading}
      >
        {saving
          ? "Saving..."
          : uploading
          ? "Uploading..."
          : "Save Changes"}
      </button>

    </div>
  );
}